import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Action, Module, VuexModule } from "vuex-module-decorators";
import {
  BootstrapDataConfig,
  BootstrapDataClause,
  BootstrapActionClause,
  BootstrapActionsConfig,
  BootstrapPosition,
} from "@/core/config/BootstrapConfig";
import store from "@/store";

@Module
export default class BootstrapModule extends VuexModule {
  dataClauses: BootstrapDataClause[] = BootstrapDataConfig;
  actionsClauses: BootstrapActionClause[] = BootstrapActionsConfig;

  @Action({ rawError: true })
  [Actions.COMMON_PROJECT_BOOTSTRAP_DATA_LIFECYCLE](params) {
    return Promise.all(
      this.dataClauses
        .filter((element: BootstrapDataClause): boolean => {
          return element.position === params.position;
        })
        .filter((element: BootstrapDataClause): boolean => {
          const prevRequestDoneAt = store.getters.requestDoneAt(element.action);
          if (prevRequestDoneAt > Date.now() - element.ttlSeconds) {
            return false;
          }

          if (element.isAllowed(params)) {
            return true;
          }

          return !!(
            "forceHandler" in element &&
            element.forceHandler &&
            element.forceHandler(params)
          );
        })
        .map((element: BootstrapDataClause) => {
          console.log(
            "data.clause",
            `${params.position} ${element.namespace} ${element.name}`
          );

          return element.handler(params);
        })
    );
  }

  @Action({ rawError: true })
  async [Actions.COMMON_PROJECT_BOOTSTRAP_ACTIONS_LIFECYCLE](params) {
    return Promise.all(
      this.actionsClauses
        .filter((element: BootstrapActionClause): boolean => {
          return element.position === params.position;
        })
        .filter((element: BootstrapActionClause) => element.isAllowed(params))
        .map((element: BootstrapActionClause) => {
          console.log(
            "action.clause",
            `${params.position} ${element.namespace} ${element.name}`
          );

          return element.handler(params);
        })
    );
  }

  @Action({ rawError: true })
  async [Actions.COMMON_PROJECT_BOOTSTRAP_BEFORE_ROUTE](route) {
    console.log(Actions.COMMON_PROJECT_BOOTSTRAP_BEFORE_ROUTE, route);

    await this.context
      .dispatch(Actions.COMMON_PROJECT_BOOTSTRAP_ACTIONS_LIFECYCLE, {
        route,
        position: BootstrapPosition.BEFORE_ROUTE,
      })
      .catch(console.error);

    await this.context
      .dispatch(Actions.COMMON_PROJECT_BOOTSTRAP_DATA_LIFECYCLE, {
        route,
        position: BootstrapPosition.BEFORE_ROUTE,
      })
      .catch(console.error);

    return true;
  }

  @Action({ rawError: true })
  async [Actions.COMMON_PROJECT_BOOTSTRAP_AFTER_ROUTE](route) {
    console.log(Actions.COMMON_PROJECT_BOOTSTRAP_AFTER_ROUTE, route);

    await this.context
      .dispatch(Actions.COMMON_PROJECT_BOOTSTRAP_ACTIONS_LIFECYCLE, {
        route,
        position: BootstrapPosition.AFTER_ROUTE,
      })
      .catch(console.error);

    await this.context
      .dispatch(Actions.COMMON_PROJECT_BOOTSTRAP_DATA_LIFECYCLE, {
        route,
        position: BootstrapPosition.AFTER_ROUTE,
      })
      .catch(console.error);

    return true;
  }

  @Action
  async [Actions.COMMON_RESET]() {
    this.context.commit(Mutations.COMMON_DICTIONARY_PURGE);
    this.context.commit(Mutations.COMMON_ACTIVITY_RESET);
    this.context.commit(Mutations.MANAGER_AFFILIATE_COMPANIES_RESET);
    this.context.commit(Mutations.MANAGER_ANNOUNCEMENTS_RESET);
    this.context.commit(Mutations.MANAGER_COMPANY_PRODUCTS_RESET);
    this.context.commit(Mutations.MANAGER_COMPANY_STATISTIC_RESET);
    this.context.commit(Mutations.MANAGER_COMPLIANCE_TRACKINGS_RESET);
    this.context.commit(Mutations.COMMON_NOTIFICATIONS_RESET);
    this.context.commit(Mutations.MANAGER_COMPANY_WALLETS_RESET);
    this.context.commit(Mutations.ADMIN_BANK_ACCOUNTS_RESET);
    this.context.commit(Mutations.ADMIN_ANNOUNCEMENTS_RESET);
    this.context.commit(Mutations.ADMIN_AUTH_CHECKPOINTS_RESET);
    this.context.commit(Mutations.ADMIN_COMPANIES_RESET);
    this.context.commit(Mutations.ADMIN_USERS_RESET);
    this.context.commit(Mutations.COMMON_REQUEST_STATS_RESET);

    await this.context.dispatch(Actions.THEME_LIVECHAT_REMOVE);

    return this.context.dispatch(Actions.MANAGER_COMPANY_ACCOUNTS_RESET);
  }
}
